package link.erpango.quip.data.remote.repository.user

import kotlinx.serialization.builtins.ListSerializer
import link.erpango.quip.data.remote.ApiClient
import link.erpango.quip.data.remote.DResponse
import link.erpango.quip.data.remote.repository.IApiRepository
import link.erpango.quip.domain.entities.DUser

class UserRepository(
    override val api: ApiClient,
): IUserRepository, IApiRepository<ApiClient> {
    override val resourcePath: String
        get() = "api/users"

    override suspend fun getUser(userId: String): DResponse<DUser> {
        return this.api.consume("$resourcePath/$userId/")
            .get()
            .response(DUser.serializer())
    }

    /**
     * Lista todos los usuarios (GET "api/users/").
     * Limitación conocida: el backend no soporta `?search=`, así que la búsqueda se hace
     * en el cliente sobre la lista completa.
     */
    override suspend fun getUsers(): DResponse<List<DUser>> {
        return this.api.consume("$resourcePath/")
            .get()
            .response(ListSerializer(DUser.serializer()))
    }
}